module.exports = __webpack_public_path__ + "static/media/icon-page-bordered.d041da61.svg";